module.exports = __webpack_public_path__ + "static/img/shangpiaosurong@2x.753de21.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/platformIntroduce/shangpiaosurong@2x.png
// module id = gNRJ
// module chunks = 69